// extracted by mini-css-extract-plugin
module.exports = {"toggleSelector":"ToggleSelector_toggleSelector__2MRii","wrapper":"ToggleSelector_wrapper__1Njsq","button":"ToggleSelector_button__3x5rx","active":"ToggleSelector_active__1G3ia"};